import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { apiUrl } from "@app/const";
import { debugLog } from "@app/utils";
import { getAccessToken } from "./getAccessToken";

const skipAuthRequests = [
  "commonAuthLoginCreate",
  "commonAuthStartFreeTrialCreate",
  "commonAuthAcceptInvitationCreate",
];

debugLog("baseUrl: ", apiUrl);

export const carBaseQuery = fetchBaseQuery({
  baseUrl: apiUrl,
  prepareHeaders: async (headers, api) => {
    debugLog("fetching", api.endpoint);

    if (!skipAuthRequests.some((v) => v === api.endpoint)) {
      const accessToken = await getAccessToken(api);
      headers.set("Authorization", `Bearer ${accessToken}`);
    }

    return headers;
  },
});

export const getFetch =
  <Response, Request>(store: any) =>
  async ({
    url,
    method = "GET",
    body,
  }: {
    url: string;
    method?: "POST" | "GET";
    body?: Request;
  }) => {
    const accessToken = await getAccessToken(store);

    const baseUrl = apiUrl.at(-1) === "/" ? apiUrl.slice(0, -1) : apiUrl;

    const response = await fetch(baseUrl + url, {
      method,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: body ? JSON.stringify(body) : null,
    });
    return (await response.json()) as Response;
  };
